import { observer } from 'mobx-react';
import { autoinject, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AccountStore } from './AccountStore';

export interface IRenewCallbackProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class RenewCallbackView extends React.Component<IRenewCallbackProps> {
    public async componentDidMount() {
        await this.accountStore.renewCallback();
    }

    public render() {
        return <div />;
    }

    @inject
    private accountStore!: AccountStore;
}
